import { useTranslation } from "react-i18next";

export const NOMBRE_COLUMNAS_ASIGNACION = {
    CODIGO_CLIENTE: "CODIGO_CLIENTE",
    NOMBRE_CLIENTE: "NOMBRE_CLIENTE",
    LATITUD_CLIENTE: "LATITUD_CLIENTE",
    LONGITUD_CLIENTE: "LONGITUD_CLIENTE",
    DIRECCION_CLIENTE: "DIRECCION_CLIENTE",
    TELEFONO_CLIENTE: "TELEFONO_CLIENTE",
};

export const INDEX_COLUMNAS_ASIGNACION = {
    CODIGO_CLIENTE: 0,
    NOMBRE_CLIENTE: 1,
    LATITUD_CLIENTE: 2,
    LONGITUD_CLIENTE: 3,
    DIRECCION_CLIENTE: 4,
    TELEFONO_CLIENTE: 5,
};

export const useListaRequerimientosCliente = () => {
    const { t } = useTranslation();
    const LISTA_REQUERIMIENTOS_CLIENTE = [
        {
            index: INDEX_COLUMNAS_ASIGNACION.CODIGO_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.CODIGO_CLIENTE,
            label: t("label_codigo_cliente"),
            descripcion: t("label_codigo_cliente"),
            verMas: false,
            obligatorio: true,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE,
            label: t("label_nombre_cliente"),
            descripcion: t("label_nombre_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.LATITUD_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.LATITUD_CLIENTE,
            label: t("label_latitud_cliente"),
            descripcion: t("label_latitud_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE,
            label: t("label_longitud_cliente"),
            descripcion: t("label_longitud_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE,
            label: t("label_direccion_cliente"),
            descripcion: t("label_direccion_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE,
            label: t("label_telefono_cliente"),
            descripcion: t("label_telefono_cliente"),
            verMas: false,
            obligatorio: false,
        },
    ];
    return LISTA_REQUERIMIENTOS_CLIENTE;
};
